<template>
    <div class="view clearfix" ref="viewWrapper">
      <!-- :style='{height: pageHeight + "px"}' -->
      <topBanner></topBanner>
      <navigation></navigation>
      <div :class='{w1080:rwidth,w100:Lwidth}'>
        <router-view></router-view>
      </div>
    </div>
</template>
<style>
.view {
  width: 100%;
  max-width: 1280px;
  max-height: 764px;
  height: 100%;
  margin: auto;
  position: absolute;
  overflow: hidden;
  left: 50%;
  top: 0;
  transform: translatex(-50%);
  background-color: #fff;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}
.w1080 {
  width: calc(100% - 200px);
  float: right;
  height: calc(100% - 60px);
}
.w100 {
  width: 100%;
}
</style>
<script>
import topBanner from "./../../components/banner/topBanner.vue";
import navigation from "./../../components/navigation/navigation";
export default {
  data() {
    return {
      isShowMenu: false,
      isShowTop: true,
      rwidth: true,
      Lwidth: false,
      pageHeight: 816,
      loadMore: false
    };
  },
  components: {
    topBanner,
    navigation
  },
  created() {
    const that = this;
    this.$nextTick(() => {
      that.setHeight();
    });
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      that.setHeight();
    };
  },
  methods: {
    setHeight() {
      let pageHeight = 0;
      let screenHeight = window.innerHeight;
      if (this.isShowMenu) {
        pageHeight = screenHeight - 110;
      } else {
        pageHeight = screenHeight - 80;
      }
      this.pageHeight = pageHeight;
    }
  }
};
</script>



// WEBPACK FOOTER //
// web.vue?7b1aba87